import apiClient from '@/services/apiClient';
import type { ApiResponse } from '@/types/api';

/** Public config response (matches backend ConfigResponse) */
export interface PublicConfigItem {
  id: number;
  config_key: string;
  config_value: string;
  data_type: string;
  description: string | null;
  group_name: string | null;
  default_value: string | null;
}

/** Get a single public config value (no auth required) */
export async function getPublicConfig(configKey: string) {
  const { data } = await apiClient.get<ApiResponse<PublicConfigItem>>(
    `/public/config/${configKey}`,
  );
  return data.data;
}

/** Get all public config values (no auth required) */
export async function getPublicConfigs() {
  const { data } = await apiClient.get<ApiResponse<PublicConfigItem[]>>(
    '/public/config',
  );
  return data.data;
}
